export default {
  meta: {
    title: '采购任务管理'
  }
};
